import React from "react";
import "./searchList.scss";

const SearchList = ({ clients, onSelectClientHandler }) => {
    return (
        <div className="searchList">
            <div className="overflow-scroll" style={{ maxHeight: "250px" }}>
                <ul className="list-group">
                    {clients.map((client) => {
                        return (
                            <li
                                className="list-group-item custom-list-item"
                                key={client.id}
                                onClick={() => onSelectClientHandler(client)}
                            >
                                {client.name} {client.phone}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default SearchList;
